import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { jobPositionQuerySchema } from './job-position-query-schema';

export const jobPositionFormSchema = jobPositionQuerySchema
  .pick({
    id: true,
    department: true,
    business_discipline: true,
    salary_grade: true,
    preferred_location: true,
    preferred_relationship: true,
  })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    result_statement: z.string(),
    strategic_work: z.string(),
    tactical_work: z.string(),
    standards_work: z.string(),

    need_to_succeed: z.string(),
    expectations: z.string(),
    position_overview: z.string(),
    applicant_questions: z.string(),
    interview_questions: z.string(),
  });

export type JobPositionFormSchema = z.infer<typeof jobPositionFormSchema>;
